<template>
  <div
    v-if="deployInfo && deployInfo.branch"
    :class="isDevBranch ? 'bg-emerald-600 text-white' : 'bg-amber-500 text-white'"
    class="sticky top-0 z-50 px-4 py-2 text-center text-sm font-semibold"
  >
    <template v-if="isDevBranch"> ✓ Staging is running <strong>dev</strong> </template>
    <template v-else>
      ⚠ Staging is running <strong>{{ deployInfo.branch }}</strong> — general testing is not recommended
    </template>
  </div>
  <router-view></router-view>
  <MAdminSessionGate />
  <MDebugExport />
  <div id="modal-container"></div>
  <div id="global-croppers" class="absolute bottom-0 left-0 right-0 top-0 -z-40"></div>
</template>

<script setup lang="ts">
  import { RouterView } from 'vue-router';
  import { useAppInsightsLogger } from '@core/plugins/appInsights';
  import { useDeployInfo } from '@shared/composables/useDeployInfo';
  import { provideAutofillPolicyFromRoute, useAutofillDomGuard } from '@shared/composables/useAutofillPolicy';
  import MAdminSessionGate from '@shared/components/MAdminSessionGate/MAdminSessionGate.vue';
  import MDebugExport from '@shared/components/MDebugExport/MDebugExport.vue';

  useAppInsightsLogger();
  useAutofillDomGuard(provideAutofillPolicyFromRoute());

  const { deployInfo, isDevBranch, load } = useDeployInfo();
  load();
</script>
